import React from 'react';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { callWidgetItemDetailSummaryPreloader as ActionWidgetItemDetailSummaryPreloader } from 'ui/views/widgets/callWidgetItemDetailSummary';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { actionWidgetItemDetailSummary as ActionWidgetItemDetailSummary } from 'ui/views/widgets/actionWidgetItemDetailSummary';
 *
 * // render
 * <ActionWidgetItemDetailSummary propName='propValue'/>
 */
export const actionWidgetItemDetailSummarySuccess = ( props ) => {

    return (
        <div className='ui-action-widget-item-detail-summary'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ { dimensions: { padding: ' 10px 10px 0px '} }}
                tableResponse={ props.componentData }
                classNameTable = { 'ui-action-widget-item-detail-summary__table-container-top' }
                onActionClick={ props.onActionClick  }
            />
        </div>
    );
};

// set display name
actionWidgetItemDetailSummarySuccess.displayName = 'actionWidgetItemDetailSummarySuccess';

// set default props
actionWidgetItemDetailSummarySuccess.defaultProps = {};

// prop types
actionWidgetItemDetailSummarySuccess.propTypes = {};

export const actionWidgetItemDetailSummaryPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-call-list-widget-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <ActionWidgetItemDetailSummaryPreloader columnlength = { 6 } />
        </div>
    );
};

// set display name
actionWidgetItemDetailSummaryPreloader.displayName = 'actionWidgetItemDetailSummaryPreloader';

// set default props
actionWidgetItemDetailSummaryPreloader.defaultProps = {};

// prop types
actionWidgetItemDetailSummaryPreloader.propTypes = {};

export const actionWidgetItemDetailSummary = withNetworkState( actionWidgetItemDetailSummaryPreloader, actionWidgetItemDetailSummarySuccess );

